import { useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { MapMock } from "@/components/MapMock";
import { ProfileLink } from "@/components/ProfileDrawer";
import { relativeTime } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";

export const Tracking = () => {
  const [active, setActive] = useState([]);
  const [sites, setSites] = useState([]);
  const [guards, setGuards] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/clockins?active_only=true");
    setActive(r.data);
  }, []);

  useEffect(() => {
    load();
    api.get("/sites").then(r => setSites(r.data));
    api.get("/guards").then(r => setGuards(r.data));
    const i = setInterval(load, 15000);
    return () => clearInterval(i);
  }, [load]);

  const guard = (id) => guards.find(g => g.id === id);
  const site = (id) => sites.find(s => s.id === id);

  const points = useMemo(() => active.map(a => {
    const g = guards.find(x => x.id === a.guard_id);
    const s = sites.find(x => x.id === a.site_id);
    return {
      lat: a.lat, lng: a.lng,
      label: g?.full_name || "Guard",
      sub: `${s?.name || "Site"} · ${relativeTime(a.clock_in_at)}`,
      alert: !a.inside_geofence,
    };
  }), [active, guards, sites]);

  return (
    <div className="grid lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2">
        <MapMock points={points} sites={sites} height={520} />
      </div>
      <div className="s-card" style={{ maxHeight: 520, overflowY: "auto" }}>
        <div className="h-section mb-3">On duty · {active.length}</div>
        <div className="space-y-3">
          {active.map(a => {
            const g = guard(a.guard_id); const s = site(a.site_id);
            return (
              <div key={a.id} className="p-3 rounded-lg" style={{ background: "rgba(46,202,200,0.04)", border: "1px solid var(--border-dark)" }}>
                <div className="flex justify-between items-start">
                  <div>
                    <div style={{ fontSize: 14, color: "#fff" }}>
                      {g ? <ProfileLink kind="guard" id={g.id}>{g.full_name}</ProfileLink> : "—"}
                    </div>
                    <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>{s?.name || "—"}</div>
                  </div>
                  <StatusBadge status={a.inside_geofence ? "ACTIVE" : "INCIDENT"} label={a.inside_geofence ? "In fence" : "Out of fence"} />
                </div>
                <div className="text-muted mono" style={{ fontSize: 11, marginTop: 6 }}>
                  {a.lat.toFixed(4)}, {a.lng.toFixed(4)} · {relativeTime(a.clock_in_at)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
